
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { safeFetchGet } from "../utils";
import { useRedirect } from "../hooks";

export default function useDoubleCheck() {
  const history = useHistory();
  const redirect = useRedirect();

  useEffect(() => {
    (async () => {
      const isLoggedIn = await safeFetchGet({
        url: "/api/user/doublecheck",
      });
      if (isLoggedIn) {
        if (redirect) {
          history.push(redirect);
        } else {
          history.push("/home");
        }
      }
    })();
  }, [history, redirect]);
}
